import { useTipPrompt } from 'components/Payments/NewPayment/PaymentContent/hooks/useTipPrompt';
import GratuityModal from 'components/Payments/NewPayment/PaymentContent/components/PaymentSummary/components/GratuityModal';

const TipPrompt = ({ promptRef, displaySettings, presetTip }) => {
  const { promptTip, tipModalProps } = useTipPrompt({ displaySettings, presetTip });
  promptRef.current = promptTip;

  return <GratuityModal {...tipModalProps} />;
};

export default TipPrompt;
